import { Flex, styled } from '@withjoy/joykit';

export const EXPERIMENT_VARIANT_BANNER_HEIGHT = 56;

export const BannerWrapper = styled(Flex)`
  display: inherit;
  position: absolute;
  width: 100%;
  height: ${EXPERIMENT_VARIANT_BANNER_HEIGHT}px;
  top: 0px;
  border-top: 0px;
  padding-top: 16px;
  padding-bottom: 16px;

  @media (min-width: 863px) {
    display: none;
  }
`;
